export const EventSummarySearchState = {
  errorMessage: '',
  isLoading: false,
  results: [],
};



/** WEBPACK FOOTER **
 ** ./model/eventSummarySearchState.js
 **/